import React, { useEffect, useRef } from 'react';

import { useChatContext } from '_modules/chat/hooks/useContext';
import Message from '_modules/message/components';

import { StyledContent } from './style';

const PanelContent = () => {
  const { state } = useChatContext();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;

    if (element) element.scrollTop = element.scrollHeight;
  }, [state.messages]);

  return (
    <StyledContent ref={ref}>
      {state.messages.map((message) => (
        <Message key={message.id} message={message} />
      ))}
    </StyledContent>
  );
};

export default PanelContent;
